export const PROJECT_EXPORT_FIELD_GROUPS = [
    { key: 'basic', label: '基本資訊' },
    { key: 'schedule', label: '時程資訊' },
    { key: 'installment', label: '分期與發票' },
    { key: 'amount', label: '金額資訊' },
    { key: 'expense', label: '支出與毛利' },
];

export default [
    {
        key: 'poo', label: '單號', align: 'left', group: 'basic',
    },
    {
        key: 'customnumber', label: '自訂編號', align: 'left', group: 'basic',
    },
    {
        key: 'status', label: '狀態', align: 'center', group: 'basic',
    },
    {
        key: 'pjcaT_NAM', label: '專案類型', align: 'center', group: 'basic',
    },
    {
        key: 'nam', label: '專案名稱', width: 30, align: 'left', group: 'basic',
    },
    {
        key: 'vdR_NAM', label: '客戶', width: 20, align: 'left', group: 'basic',
    },
    {
        key: 'stF_NAM', label: '專案經理', align: 'center', group: 'basic',
    },
    {
        key: 'projectAuditorName', label: '專案經辦人', align: 'center', group: 'basic',
    },
    {
        key: 'sdt', label: '開始日期', align: 'center', group: 'schedule',
    },
    {
        key: 'edt', label: '預計結束日期', align: 'center', group: 'schedule',
    },
    {
        key: 'timeProgress', label: '時程%', align: 'left', group: 'schedule',
    },
    {
        key: 'installmentCount', label: '分期', align: 'center', group: 'installment',
    },
    {
        key: 'installmentInvoicedCount', label: '已開發票期數', align: 'center', group: 'installment',
    },
    {
        key: 'amt', label: '專案總價', align: 'right', number: true, group: 'amount',
    },
    {
        key: 'cny', label: '幣別', width: 8, align: 'center', group: 'amount',
    },
    {
        key: 'cnyRat', label: '即時匯率', width: 8, align: 'right', group: 'amount',
    },
    {
        key: 'twdAmt', label: '約當台幣', align: 'right', number: true, group: 'amount',
    },
    {
        key: 'amT_PREOUT', label: '支出總預算（台幣）', width: 20, align: 'right', number: true, group: 'expense',
    },
    {
        key: 'totalPay', label: '已支出金額（台幣）', width: 20, align: 'right', number: true, group: 'expense',
    },
    {
        key: 'profitProgress', label: '實際支出%', align: 'left', group: 'expense',
    },
    {
        key: 'disAmt', label: '折讓總額', align: 'right', number: true, group: 'expense',
    },
    {
        key: 'actualGrossProfit', label: '實際毛利', align: 'right', number: true, group: 'expense',
    },
    {
        key: 'actualGrossMargin', label: '實際毛利率', align: 'right', group: 'expense',
    },
];
